import { render, staticRenderFns } from "./rappi_general_tab.vue?vue&type=template&id=600f9fdb&scoped=true&"
import script from "./rappi_general_tab.vue?vue&type=script&lang=js&"
export * from "./rappi_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600f9fdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('600f9fdb')) {
      api.createRecord('600f9fdb', component.options)
    } else {
      api.reload('600f9fdb', component.options)
    }
    module.hot.accept("./rappi_general_tab.vue?vue&type=template&id=600f9fdb&scoped=true&", function () {
      api.rerender('600f9fdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/rappi/location/tabs/rappi_general_tab.vue"
export default component.exports